import { render } from "./VisaFacilitation.vue?vue&type=template&id=6a2066ee&scoped=true"
import script from "./VisaFacilitation.vue?vue&type=script&lang=js"
export * from "./VisaFacilitation.vue?vue&type=script&lang=js"

import "./VisaFacilitation.vue?vue&type=style&index=0&id=6a2066ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2066ee"]])

export default __exports__